<template>
  <div class="LoadProgress layout-container text-center">
    <p class="type-sm mb-24">
      {{ $t(text, {
        current: current,
        total: total
      }) }}
    </p>
    <div
      class="w-260 h-4 mx-auto bg-bg-inactive mb-20 desk:mb-24"
    >
      <div
        class="bg-bg-successStrong h-4"
        :style="{
          width: `${current / total * 100}%`,
        }"
      />
    </div>
    <button
      v-if="current < total"
      class="btn btn--secondary inline-block"
      :class="{
        loading
      }"
      type="button"
      @click="$emit('loadMore')"
    >
      {{ $t(buttonText) }}
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  current: number,
  total: number,
  text: string,
  buttonText?: string,
  loading?: boolean,
}
withDefaults(defineProps<Props>(), {
  loading: false,
  buttonText: 'filter.loadmore',
});

defineEmits(['loadMore']);
</script>
